<template>
  <div class="header-wrapper">
    <div class="header-box">
      <div class="search-wrapper flex-x-bet-y-center">
        <router-link to="/" class=" left flex-x-bet-y-center" style="text-decoration: none;">
          <img src="@/assets/img/logos.png" class="logo" alt="" />
        </router-link>
        <div class="center flex-x-bet-y-center flex-1">
          <div class="flex-y-center flex-1">
            <el-select v-model="searchType" @change="onChanges" :popper-append-to-body="false">
              <el-option v-for="(item, index) in searchTypeList" :key="item.value" :value="item.value"
                :label="item.label"></el-option>
            </el-select>
            <input type="text" @focus="handleFocus" v-model="keywords" placeholder="请输入.." class="search-input" />
          </div>
          <i v-if="icon_del" class="el-icon-circle-close dels" @click="delInpurt"></i>
          <div class="search-btn flex-xy-center" @click="searchConfirm">
            <img src="@/assets/img/icon-search.png" class="icon-search" alt="" />
          </div>
        </div>
        <div class="right flex-y-center">
          <el-button type="primary" style="background-color: #3a71fb; border: 0"
            @click="choosePublishType">发布商品</el-button>
          <!-- <el-button type="primary" @click="$router.push('/demandPublish/index')">发布需求</el-button> -->
          <el-button type="primary" @click="goDemand">发布需求</el-button>
          <div class="phones">
            咨询热线: 400-189-1168
          </div>
        </div>


        <div v-if="PosSwitch" class="dingwei">
          <span style="margin-right: 10px; font-weight: 600;" class="sizeColor">{{ cityname }}</span>
          [ <a href="javasrcipt:;" @click="drawer = true" class="sizeColor">切换城市</a>
          <!-- 位置： {{ address }} -->
          ]
        </div>
      </div>

    </div>

    <div class="tab-list">
      <div class="boxAll">
        <!-- 首页三级菜单-top -->
        <div class="allHeader" @mouseover="showMenu" @mouseleave="hideMenu">
          <span> 全部类别</span>
          <img :src="require('@/assets/img/icon-All.png')" alt="">
          <!-- 一级 -->
          <div v-if="isMenuVisible" class="oneMin">
            <div class="bigin" v-for="(item, index) in menuData" :key="index">
              <div>{{ item.categoryTitle }}</div>
              <img src="../assets/img/arrow-right1.png" alt="">
              <div class="twoMin">
                <div class="box-min" v-for="(items, i) in item.children" :key="i">
                  <!-- 二级 -->
                  <div v-if="isMenuVisible" class="twoMin_lift">
                    <div>
                      {{ items.categoryTitle }}
                    </div>
                    <img src="../assets/img/arrow-right1.png" alt="">
                  </div>
                  <!-- 三级 -->
                  <div class="twoMin_right">
                    <span class="cate" :class="{ active: ite.id === classId }" @click="menuItemClicked(ite, type)"
                      v-for="(ite, type) in items.children">{{
                        ite.categoryTitle
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="tab" v-for="(item, index) in tabList" :class="{ active: currentTab === index }" :key="index"
        @click="toggleTab(index)">
        {{ item.name }}
      </div>
    </div>
    <div class="line"></div>
    <div style="background-color: #F7F7F7;width:100%;">
      <Breadcrumb ref="Breadcrumb"></Breadcrumb>
    </div>

    <!-- 切换地址上方抽屉 -->
    <el-drawer title="欢迎来到Q7~ 请选择城市。" style="height: 1500px; overflow: hidden;" class="custom-drawer"
      :visible.sync="drawer" direction="ttb" :before-close="handleClose">
      <div style="padding: 0 200px;font-size: 18px;">
        <div class="filter-wrapper">
          <div class="filter-rows flex">
            <div class="cate-title">默认：</div>
            <div class="flex-y-center relative" style="flex-wrap: wrap">
              <div class="flex-y-center  cate" :class="{ active: 1 == nationalId }" @click=" selectArea(1, '全国', '')">
                全国
              </div>
            </div>
          </div>
          <div class="filter-rows flex">
            <div class="cate-title">地区：</div>
            <div class="flex-y-center relative" style="flex-wrap: wrap;">
              <div class="flex-y-center cate" :class="{ active: item.code === classProvince }"
                @click="selectArea(item.code, 'province', item.disName)" v-for="(item, index) in areas"
                :key="item.code">
                {{ item.disName }}
              </div>
            </div>
          </div>
          <div class="filter-rows flex">
            <div class="cate-title">城市：</div>
            <div class="flex-y-center relative" style="flex-wrap: wrap">
              <div class="flex-y-center cate" :class="{ active: item.code === classCityId }"
                @click="selectArea(item.code, 'city', item.name)" v-for="(item, index) in city" :key="item.code">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>


  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { getUserInfo } from '@/api/user.js'
import {
  getCategory,
} from "@/api/product.js";
import {
  mapGetters
} from 'vuex'
import { getCity } from '@/api/common.js';
import { getCitylist } from '@/api/manufacturerssupply.js';

import AMapLoader from '@amap/amap-jsapi-loader';
window._AMapSecurityConfig = {
  // 安全密钥
  securityJsCode: "f26e13b8273c8f552cf03425c1bc4d7a",
};
export default {
  name: "PageHeader",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      classCityId: '',//:class
      classCategoryId: '',//:class
      classProvince: '',//：class
      nationalId: '1',//:class
      areas: [],//地区
      city: [],//城市
      drawer: false,//抽屉开关
      cityname: '全国',//用来存选择的城市名字用来展示  默认显示全国

      // -----
      address: '',
      activeIndex: '1',
      icon_del: false,//用来显示隐藏del
      amountBalances: '',
      searchType: 1, // 1厂商  2二手 3租赁 4需求
      searchType2: 0, // ''全部 1设备 2建材
      keywords: '', // 关键字
      searchTypeList: [
        { label: "厂商", value: 1 },
        { label: "二手", value: 2 },
        { label: "租赁", value: 3 },
        { label: "需求", value: 4 },
        { label: "排行", value: 5 },
      ],
      tabList: [
        { name: "首页", path: "/index" },
        { name: "厂家货源", path: "/productList/factory" },
        { name: "二手货源", path: "/productList/used" },
        { name: "租赁货源", path: "/productList/rentOut" },
        { name: "需求大厅", path: "/demandHall" },
        { name: "商家排行", path: "/storeRanking/Index" },
      ],
      productTypeList: [
        { label: "全部商品", value: 0 },
        { label: "设备", value: 1 },
        { label: "建材", value: 2 },
      ],
      currentTab: 0,
      menuData: [],
      // 地址逆解析
      geoCoder: null,
      PosSwitch: false,
      classId: '',
      isMenuVisible: false, // 控制菜单显示与隐藏
      routerId: 1,//用来存跳转哪个页面
    };
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.getLocation()
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo()
      this.PosSwitch = true
    }
    this.getCategory()
    this.getCity()
  },
  computed: {
    ...mapGetters(['isLogin', 'userInfo'])
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        let index = this.tabList.findIndex(item => item.path === val.fullPath)
        if (index > -1) {
          this.currentTab = index
          if (index != 0) {
            this.searchType = index
          } else {
            this.searchType = 1
          }
        }
        // this.cityname = '全国'//切换路由的时候清除掉选择的地址
        //路由变化初始化选择高亮 
        // this.classCityId = ''
        // this.classProvince = ''
        this.getCitylist(this.classProvince)
		this.$refs.Breadcrumb.show(this.$route.name)
      }
    },
  },

  methods: {
    //选择在城市点击事件
    selectArea(code, type, names) {
      if (type === 'province') {//省
        this.getCitylist(code);
        this.classProvince = code
        this.nationalId = ''
      } else if (type === 'city') {//市
        this.classCityId = code
        this.cityname = names
        this.drawer = false
        this.$emit('selectArea', {
          code: code,
          name: names
        })
      } else if (type == '全国') {
        this.nationalId = code
        this.cityname = type
        this.classProvince = ''
        this.classCityId = ''
        this.drawer = false
        this.$emit('selectArea', {
          code: '',
          name: type,
        })
      }
    },

    getCity() {
      getCity({ level: 2, p_code: "" }).then((res) => {

        this.areas = res.result
        console.log(res, '省份');
        if (this.areas.length > 0) {
          this.getCitylist(this.areas[0].p_code); // 获取第一个省份的城市数据
        }
      })
    },
    getCitylist(pCode) {
      if (!pCode) pCode = '110000'  //默认显示北京
      getCitylist({ level: 3, p_code: pCode }).then((res) => {
        this.city = res.result
      })
    },


    // ------------------------
    showMenu() {
      this.isMenuVisible = true;
    },
    hideMenu() {
      this.isMenuVisible = false;
    },
    goLogin() {//游客模式提示弹窗
      this.$confirm('您还未登录，请登陆后浏览', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '去登陆',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$router.push('/login')
        })
    },

    menuItemClicked(type, indexPath) {
      this.classId = type.id
      let key = type.id
      let name = type.categoryTitle
      console.log(`key:${key},name:${name}  11`);
	  if (this.$route.path == '/productList/factory' || this.$route.path == '/productList/used' || this.$route.path == '/productList/rentOut') {
		  this.$emit('allHeader', { key, name });
	  }
      this.isMenuVisible = false; // 关闭菜单
      if (this.searchType == 4) {
        this.$emit('serfunch', {
          keywords: name,
        })
      }
      if (this.searchType == 5) {
        this.$emit('Ranking', {
          mainBusiness: name,
        })
      }
      // if (this.searchType == 1) {
      //   this.$router.push(this.tabList[this.searchType].path)
      // } else {
      this.$router.push(this.tabList[this.searchType].path)
      // }
    },
    // handleSelect(key, indexPath) {
    //   this.activeIndex = '1'
    //   let index = this.menuData.findIndex(item => item.id == indexPath[1])
    //   let indexs = this.menuData[index].children.findIndex(item => item.id == indexPath[2])
    //   let name = this.menuData[index].children[indexs].children.find(item => item.id == indexPath[3]).categoryTitle
    //   this.$emit('allHeader', { key, name });
    //   this.$router.push('/productList/factory')
    // },
    getCategory() {
      getCategory({}).then(res => {
        this.menuData = res.result
      })
    },

    handleFocus() {//监听input聚焦
      this.icon_del = true
    },
    toggleTab(index, query = null) {
      if (index != 0) { //排除首页
        this.searchType = index //用来绑定选择切换菜单搜索框前面也变
        this.routerId = index
      } else if (index == 0) {
        this.searchType = 1 //回到厂家货源
      }
      this.currentTab = index;
      // if (!localStorage.getItem('token') && index == 4 || !localStorage.getItem('token') && index == 5) {
      //   this.goLogin()
      // } else {
      //   this.$router.push({ path: this.tabList[index].path, query });
      // }
      this.$router.push({ path: this.tabList[index].path, query });

    },

    getUserInfo() {
      getUserInfo().then((res) => {
        this.amountBalances = res.result.isFirm
      })
    },
    choosePublishType() {
      // if (!localStorage.getItem('token')) return this.goLogin()
      this.$router.push('/publishType')
    },
    goDemand() {
      // if (!localStorage.getItem('token')) return this.goLogin()

      this.$router.push('/demandPublish/index')
    },
    delInpurt() {
      this.keywords = ''
      this.icon_del = false
      this.$emit('delKeyWord')
    },
    onChanges() {
      this.toggleTab(this.searchType, {});
    },
    searchConfirm() {
      this.toggleTab(this.searchType, {});

      this.$emit('serfunch', {
        keywords: this.keywords,
      })
    },
    setleiChange() {
      this.$emit('updateProductType', this.searchType2);
    },
    headerRefFun() {
      this.keywords = ''
    },
    delHeader() { //切换页面销毁前调用这个
      this.getCitylist(this.classProvince)
      if (this.city) {
        this.$emit('selectArea', {
          code: this.classCityId,
          name: this.cityname
        })
      }
    },
    delHeas(type) {// 一手 二手 租赁 的清除
      this.nationalId = ''
      if (type == 6) {
        this.classId = ''//初始化三级的选择
        this.selectArea(this.classCityId, 'city', this.cityname)
      } else
        if (type) {
          this.classId = ''
          // this.cityname = '全国'
          // this.classCityId = ''
          // this.classProvince = ''
          // this.getCitylist()
        } else {
          this.selectArea(this.classCityId, 'city', this.cityname)
        }
    },
    // ---
    getLocation() {
      AMapLoader.load({
        key: '5adf5a23533786b822ab6fe6f1e0cd53', // 请替换成你的API Key
        version: '2.0',
        plugins: ["AMap.Geolocation", "AMap.Geocoder", "AMap.AutoComplete", "AMap.ToolBar", "AMap.HawkEye"],
      }).then(AMap => {
        console.log(AMap, 'AMap');

        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000,          // 超过10秒后停止定位，默认：5s
          zoomToAccuracy: true     // 定位成功后是否自动调整地图视野到定位点
        });
        // console.log(geolocation, 'geolocation');

        //地址逆解析插件
        this.geoCoder = new AMap.Geocoder({
          city: "010", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        });

        geolocation.getCurrentPosition();
        geolocation.on('complete', (data) => {

          this.toGeoCoder([data.position.getLng(), data.position.getLat()])
        });
        geolocation.on('error', (error) => {
          // this.$message.warning('定位失败无法展示位置，请检查您的定位权限设置');
          this.address = "定位失败,请检查您的定位权限设置"
        });
      }).catch(e => {
        // console.error('高德地图加载失败', e);
      });
    },
    // 逆解析地址
    toGeoCoder(lnglat) {
      this.geoCoder.getAddress(lnglat, (status, result) => {
        if (status === "complete") {
          this.address = result.regeocode.formattedAddress || '暂无地址';
        } else {
          this.forms.address = '地址获取失败，请检查经纬度或服务状态';
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sizeColor {
  color: #FE5A13 !important;
  font-weight: 500;
}

.phones {
  font-size: 16px;
  color: #302e2e;
  position: absolute;
  right: -220px;
  top: 15px;

}

.dingwei {
  position: absolute;
  left: 10px;
  top: -80px;
  height: 30px;
  // background: yellow;
  color: #302e2e;
  line-height: 30px;
  font-size: 16px;

  a {
    text-decoration: none;
  }
}

.default-yellow {
  background-color: #fe5a13 !important;
  width: 200px;
}

.allyi {
  background: #fff;
  width: 100%;
  height: auto;
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 9999;
  color: #000;
  display: none;

  div:hover {
    color: #fe5a13;
  }

  div {
    font-size: 16px;
    line-height: 32px;
    padding-left: 20px;
    position: relative;
  }

  .aller {
    width: 170px;
    height: 100%;
    background: yellow;
    position: absolute;
    top: 0;
    left: 190px;

    .all3 {
      width: 170px;
      height: 100%;
      background: pink;
      position: absolute;
      top: 0;
      left: 190px;
    }
  }
}


.boxAll {
  color: #fff;
  // overflow: hidden;
  position: relative;

  .oneMin {
    width: 198px !important;
    background: #FE5A13;
    height: 550px;
    position: absolute;
    top: 61px;
    left: 0;
    z-index: 999;
    border: 1px solid #FE5A13;
    font-weight: 400;
    display: none;

    >div:hover {
      background: #fff;
      color: #FE5A13;
    }

    >div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      text-align: center;
      line-height: 50px;
      font-size: 18px;
      cursor: pointer;
      padding: 0 10px;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .twoMin {
    background: #fff;
    height: 550px;
    width: 1000px;
    position: absolute;
    top: -1px;
    left: 199px;
    z-index: 999;
    border: 1px solid #FE5A13;
    color: #575252;
    overflow: hidden;
    overflow-y: auto;

    display: none;

    >.box-min {
      width: 100%;
      height: auto;
      // background: yellow;
      display: flex;
      align-items: center;

      .twoMin_lift {
        min-width: 200px;
        // background: red;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 30px;
        box-sizing: border-box;
        font-size: 16px;
        cursor: pointer;

        img {
          width: 15px;
          height: 15px;
        }
      }


      .twoMin_right {
        flex: 1;
        border-bottom: 1px solid #ebe5e5;
        font-size: 14px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        // background: pink;
        overflow: hidden;

        .active,
        .cate:hover {
          background: #fe5a13;
          color: #fff;
        }

        >span {
          // min-width: 130px;
          height: auto;
          height: 30px !important;
          line-height: 30px;
          display: block;
          border-left: 2px solid #ebe5e5;
          margin: 2px 0 !important;
          padding: 0 10px;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
    }
  }

  .allactive {
    background: #d84405 !important;
  }

  .allHeader {
    width: 200px !important;
    height: 60px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-left: 20px;
    background: #FE5A13;
    box-sizing: border-box;
    // border-radius: 4px;

    img {
      width: 20px;
      height: 20px;
      margin-left: 30px;
    }
  }


}


.dels {
  color: #818181;
  font-size: 18px;
  margin-right: 10px;
}

.header-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background: #fff;

  .header-box {
    width: 1200px;
    padding: 40px 0;

    .search-wrapper {
      height: 55px;
      position: relative;

      .left {
        .logo {
          width: 240px;
          height: 100px;
        }

        .name {
          font-weight: 800;
          font-size: 30px;
          color: #333333;
        }
      }

      .center {
        height: 100%;
        position: relative;
        margin: 0 50px;
        width: 647px;
        background: #ffffff;
        border-radius: 0px;
        border: 2px solid #fe5a13;
        // height: 0.5625rem;

        .search-input {
          flex: 1;
          border: 0;
          outline: none;
          border-left: 1px solid #ccc;
          padding: 0 20px;
          height: 35px;
        }

        input {
          font-size: 18px;
        }

        ::v-deep .el-input__inner {
          font-size: 18px;
        }

        ::v-deep .el-select-dropdown__item {
          font-size: 18px;
        }
      }


      .search-btn {
        width: 59px;
        height: 100%;
        background: #fe5a13;
        cursor: pointer;

        .icon-search {
          width: 26px;
          height: 26px;
        }
      }
    }
  }

  .tab-list {
    display: flex;
    width: 1200px;

    .tab {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      padding: 17px 0;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      cursor: pointer;
    }

    .active {
      font-weight: bold;
      color: #fe5a13;
    }

    .select {
      display: flex;
      align-items: center;
      flex: 1;
      background: #fe5a13;
      position: relative;

      ::v-deep .el-input__inner {
        background-color: #fe5a13;
        width: 100%;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
      }

      ::v-deep .el-select__caret {
        color: #fff;
      }

      ::v-deep .el-select-dropdown__item {
        font-size: 18px;
      }
    }
  }

  .line {
    width: 100%;
    height: 2px;
    background: #fe5a13;
  }
}

.filter-wrapper {
  width: 1200px;
  background: #ffffff;
  margin: auto;

  .choosed,
  .filter-rows {
    padding: 20px 30px;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
  }

  ::v-deep .el-tag--mini {
    font-size: 16px;
  }

  .clear-choosed {
    width: 120px;
    height: 30px;
    background: #fe5a13;
    border-radius: 15px;
    color: #fff;
    cursor: pointer;
  }

  .filter-rows {
    border-top: 1px solid #f1f1f1;
    padding-bottom: 12px;

    .cate-title {
      flex-shrink: 0;
      margin-right: 30px;
      margin-bottom: 8px;
      padding-top: 5px;
    }

    .cate {
      color: #818181;
      margin-right: 30px;
      padding: 5px 9px;
      border-radius: 4px;
      cursor: pointer;
      margin-bottom: 8px;
    }

    .active,
    .cate:hover {
      background: #fe5a13;
      color: #fff;
    }
  }
}

::v-deep .el-input__inner {
  border: 0;
  width: 104px;
}

::v-deep .el-select {
  position: relative;
}

// 下拉框选中修改文字颜色
::v-deep .selected {
  color: #fe5a13 !important;
}

.bigin:hover .twoMin {
  display: block !important;
}

.allHeader:hover .oneMin {
  display: block !important;

}

::v-deep .custom-drawer .el-drawer__header {
  background-color: #F4F4F4;
  /* 修改背景颜色 */
  color: #333;
  /* 修改文字颜色 */
  font-size: 16px;
  /* 修改文字大小 */
  padding: 15px;
  /* 修改内边距 */
  height: 40px;
  padding: 0 350px;
  box-sizing: border-box;
}
</style>